import animateOneLiner from "../../../util/animateOneLiner/animateOneLiner";

export default function(o, aaTagsData){

  var lang = o.store('lang')

  var saveScrollPosition = function(){
    o.store('antiArchiveTagsDivScrollPosition',div[0].scrollLeft)
  }

  var tagsDiv = $('<div>')
  .css({
    fontSize: o.fontSizeDef.l,
    margin: '0.9rem 0.5rem',
  })

  var startTag = function(tagSlug){
    return function(){

        div.off('scroll',saveScrollPosition)
    
        o.log('antiArchiveTagClick',tagSlug)
    
        o.store('antiArchiveTagClicked_' + tagSlug, true)
    
        history.pushState({}, '', `/anti-archive/${tagSlug}`)
        o.render(o)
    
        if(!o.store('soundOff')){
          o.util.soundPlay(o,1000,true)
        }
    }
  }

  var randomLabel =
    o.util.getTranslation(o, 'random')

  var randomDiv = 
    o.component.button(o, randomLabel, startTag('random'))
    .css({
      margin: '0.4rem 0.5rem',
      marginLeft: '0.7rem',
    })

  if(o.store('antiArchiveTagClicked_random')){
    randomDiv.children().first().addClass('visited')
  }

  tagsDiv
  .append(randomDiv)

  for (var i = 0; i < aaTagsData.length; i++) {

    var t = aaTagsData[i]
    var tagLabel = t[lang]
    var tagSlug = Slug(t.en)

    var tagDiv =
      o.component.button(o, tagLabel, startTag(tagSlug), false, false, true)
      .css({
        margin: '0.4rem 0.5rem',
      })

    if(o.store('antiArchiveTagClicked_' + tagSlug)){
      tagDiv.children().first().addClass('visited')
    }

    tagsDiv
    .append(tagDiv)

  }

  tagsDiv
  .append([
    $('<div>')
    .css({
      display: 'inline-block',
      width: '0.7rem',
    })
  ])

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
    })
    .append(tagsDiv)

  if(!o.isTouch){
    animateOneLiner(o,div)
  }

  div.on('scroll',saveScrollPosition)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchive/tags/tags.js